// @flow
import React, {Component} from 'react';
import {Range} from 'rc-slider';
import './Slider.less';
import SliderHandle from '../SliderHandle/SliderHandle';

type Props = {
    min?: number,
    max: number,
    step: number,
    start: number,
    stop: number,
    onChange: (Array<number>) => any
};

type State = {
    start: number,
    stop: number
};

const MIN_SPACING_INTERVAL = 20;

class Slider extends Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {
            start: props.start,
            stop: props.stop
        };
    }

    componentWillReceiveProps(nextProps: Props) {
        const {start, stop} = nextProps;
        this.setState({start, stop});
    }

    handleChange = (bounds: Array<number>) => {
        const {onChange, max} = this.props;
        const min = this.props.min || 0;
        const {start, stop} = this.state;
        const minSpacing = (max - min) / MIN_SPACING_INTERVAL;

        // if the bounds are too close, space them out to be as close as possible
        // without overlapping
        let newStart = bounds[0];
        let newStop = bounds[1];

        if (bounds[1] - bounds[0] < minSpacing) {
            // it's not possible to move both handles at the same time so at most only 1
            // bound will be changing
            if (bounds[0] !== start) {
                newStart = newStop - minSpacing;
            }
            if (bounds[1] !== stop) {
                newStop = newStart + minSpacing;
            }
        }

        this.setState({
            start: newStart,
            stop: newStop
        });
        onChange([newStart, newStop]);
    };

    render() {
        const {min, max, step} = this.props;
        const {start, stop} = this.state;
        return (
            <Range
                className="Slider"
                min={min}
                max={max}
                step={step}
                value={[start, stop]}
                allowCross={false}
                onChange={this.handleChange}
                handle={SliderHandle}
            />
        );
    }
}

export default Slider;
